import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Pathway } from './components/sections/Pathway';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Scenario } from './components/sections/Scenario';
import { Audience } from './components/sections/Audience';
import { Author } from './components/sections/Author';
import { Testimonials } from './components/sections/Testimonials';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-sans text-white" data-id="element-0" data-mp="3iiwdwl3utc1n">
      <MetaPixel data-id="element-1" data-mp="3mkrdnl64zhdb" />
      <Hero data-id="element-2" data-mp="3mk8710lxsfel" />
      <main data-id="element-3" data-mp="3mjztr7lwj82v">
        <Problem data-id="element-4" data-mp="3mjg9hk8s47lo" />
        <BeforeAfter data-id="element-5" data-mp="3rc9f0ac2njyt" />
        <Pathway data-id="element-6" data-mp="3rbrbcsn2y3gv" />
        <Volumes data-id="element-7" data-mp="3rdaselgk8ijp" />
        <Bonuses data-id="element-8" data-mp="3rcswjpxt86cb" />
        <Scenario data-id="element-9" data-mp="3recdlirailf5" />
        <Audience data-id="element-10" data-mp="5yhupa6n3cr" />
        <Author data-id="element-11" data-mp="6hpnd64cbd2" />
        <Testimonials data-id="element-12" data-mp="4wwnrzgd0hb" />
        <Offer data-id="element-13" data-mp="56ntiw8hdol" />
        <Guarantee data-id="element-14" data-mp="82ohezguggq" />
        <Faq data-id="element-15" data-mp="2zld0z6e9z99y" />
        <FinalCta data-id="element-16" data-mp="2zlld2w2kqak3" />
      </main>
      <FloatingCta anchorId="first-cta" data-id="element-17" data-mp="2zmo4r67q0h12" />
      <PurchasePopup data-id="element-18" data-mp="33mouvo46mgny" />
    </div>;
}